// extracted by mini-css-extract-plugin
export default {"button":"button--SlOfU","decor":"decor--Gyh3J"};